import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ImageSaudi from "../../assets/images/flagSaudi.webp";
import ImageUnitedkingdom from "../../assets/images/flagUnitedkingdom.webp";
import { changeUserLanguage } from "../../redux/reducer/languageReducer";
import { useDispatch } from "react-redux";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const LanguageToggleButton = ({ rounded, desktop, language, accessToken }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const direction = useLanguageDirection();
  const [currentLanguage, setCurrentLanguage] = useState(direction || "ltr");
  const dispatch = useDispatch();
  // Function to get the path without language prefix
  const getPathWithoutLanguage = (pathname) => {
    if (pathname.startsWith("/ar/") || pathname.startsWith("/en/")) {
      return pathname.substring(3);
    }
    if (pathname === "/ar" || pathname === "/en") {
      return "/";
    }
    return pathname;
  };

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === "ltr" ? "ar" : "en";

    dispatch(changeUserLanguage());
    localStorage.setItem("language", newLanguage);

    sessionStorage.setItem("isLanguageSwitching", "true");

    let currentPath = location.pathname.replace(/^\/(ar|en)/, "");
    if (!currentPath.startsWith("/")) {
      currentPath = "/" + currentPath;
    }

    navigate(`/${newLanguage}${currentPath}`);
  };

  const flagImage = currentLanguage === "rtl" ? ImageUnitedkingdom : ImageSaudi;

  return (
    <button
      onClick={toggleLanguage}
      className={`relative gap-2 flex items-center justify-center lg:w-[90px] group ${
        desktop && "flex-row-reverse"
      }`}
      style={{ marginLeft: 0 }}
    >
      {/* Flag */}
      <img
        src={flagImage}
        alt={currentLanguage === "ar" ? "English Flag" : "Kuwait Flag"}
        className={
          rounded
            ? `me-2 w-5 h-5 lg:w-10 lg:h-6 ${rounded}`
            : "w-6 h-6 lg:w-7 lg:h-7 rounded-full"
        }
      />
      <span className="text-white duration-300 group-hover:text-custom-yellow">
        {direction === "rtl" ? "English" : "العربية"}
      </span>
    </button>
  );
};

export default LanguageToggleButton;
